import "./index.css"
import CalendarGrid from "../calendar-grid";
import { useState } from "react";
import Button from "../button";
import { schedulePost } from "../../functions/schedulePost";


function IdeaScheduler({display,close,id}) {
    const [monthToDisplay,SetMonthToDisplay] = useState(new Date());
    const [selectedScheduledDate,SetSelectedScheduledDate] = useState(null);

    const moveToNextMonth = () => {
      let currentMonth = monthToDisplay;
      let newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
      SetMonthToDisplay(newMonthToDisplay);
    }

    const moveBackAMonth = () => {
      let currentMonth = monthToDisplay;
      let newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
      SetMonthToDisplay(newMonthToDisplay);
    }

    const logScheduledDate = async(date) => {
        let schedulingDate = new Date(monthToDisplay.getFullYear(),monthToDisplay.getMonth() , date);
        await schedulePost(id,schedulingDate);
        
    }

    return <div id="idea-scheduler-holder" style={{display:display}}>
        <div id="idea-scheduler">
        <div className="idea-schedule-header">
          <h2 className="idea-schedule-month">{monthToDisplay.toLocaleString('default', { month: 'long' })} {monthToDisplay.getFullYear()}</h2>
          <div className="idea-scheduled-header-button-holder">
            <img onClick={moveBackAMonth} className="idea-schedule-icon month-skip" id='back-month' src="./images/next.png"></img>
            <img onClick={moveToNextMonth} className="idea-schedule-icon month-skip" id='forward-month' src="./images/next.png"></img>
            <img className="idea-schedule-icon close" onClick={close} src="./images/close.png"></img>
          </div>
        </div>
        <CalendarGrid time={monthToDisplay} SetSelectedScheduledDate={SetSelectedScheduledDate} expandedBool={false}/>
        <div>
        <Button text="Schedule post" addedFunction={logScheduledDate} params={selectedScheduledDate}></Button>
        </div>
        </div>
    </div>
  }

export default IdeaScheduler;